import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface FloorPlanStoreState {
  isPanning: boolean;
  isZooming: boolean;
  setIsPanning: (isPanning: boolean) => void;
  setIsZooming: (isZooming: boolean) => void;
  getIsPanning: () => boolean;
  getIsZooming: () => boolean;
}

export const useFloorPlanStore = create<FloorPlanStoreState>()(
  devtools((set, get) => ({
    isPanning: false,
    isZooming: false,
    setIsZooming(isZooming) {
      set(() => ({ isZooming }));
    },
    getIsZooming: () => get().isZooming,
    getIsPanning: () => get().isPanning,
    setIsPanning(isPanning) {
      set(() => ({ isPanning }));
    },
  })),
);
